export default __webpack_public_path__ + "static/media/home-screen.67b2d0a9.svg";